export const BLANK_PATTERN = /_{3}/g;

export type FillInTheBlankSegment =
  | { type: 'text'; value: string }
  | { type: 'blank'; index: number };

export function parseFillInTheBlank(question: string): FillInTheBlankSegment[] {
  const parts = question.split(BLANK_PATTERN);
  const segments: FillInTheBlankSegment[] = [];

  parts.forEach((text, index) => {
    if (text) segments.push({ type: 'text', value: text });
    if (index < parts.length - 1) segments.push({ type: 'blank', index });
  });

  return segments;
}
